import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetwork = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 16,
			width: 6,
			height: 6,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 16,
			width: 6,
			height: 6,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 2,
			width: 6,
			height: 6,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12V8" })
	]
});
export { SvgNetwork as ReactComponent };
